// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const GimpIcon = createSvgIcon(
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24">
    <path
      fill="#8C8073"
      d="M22.2 2.45q-.12 0-.26.17a12.4 12.4 0 0 1-7.27 5.06 3.2 3.2 0 0 1 2.11 1.04A3.32 3.32 0 0 1 15.66 14a3.2 3.2 0 0 1-3.17-.4 3.3 3.3 0 0 1-1.16-1.73q-.26.82-.9 1.33a2.22 2.22 0 0 1-2.35.3q-.45-.21-.8-.6a3.04 3.04 0 0 1 0-3.89c.47-.5 1.09-.8 1.74-.8q.78.01 1.42.52.63.52.89 1.35a3.3 3.3 0 0 1 1.72-2.08 6.5 6.5 0 0 1-3.97-.6A5.7 5.7 0 0 1 6.8 5.23q-.06-.1-.14-.02a58 58 0 0 0-.9 5.7c-.03 1.5-.65 3.3-2.5 3.36 1.7 3.48 5.42 5.01 9.7 4.95 1.28 0 3.05-.3 4.74-1.14l-1.44-.91c-1.23.72-2.69 1-4.28.93-2.03-.08-1.7-.67-1.25-.61 3.28.46 5.34-.57 6.7-2.34l-.5-.34c-.15-.1.02-.27.35-.28h.04q.28-.01.66.19c.7.4.72.88.49.99-.08.03-.24-.05-.4-.14q-.36.45-.75.81c.62.27 1.44.63 1.84.82a9 9 0 0 0 2.77-3.28c2-4.07.6-11.16.56-11.26s-.14-.2-.22-.2z"
    />
    <path
      fill="#000"
      d="M19.7 17.68h-.09c-.25.08-.59.68-.51.94s.32.14.48.22c.13.08.18.3.36.3-.03.41.12.83.37 1.13.42.52 1.07.53 1.49.62.41.1.72.35.87.63.12.23.37-.88.28-1.66-.18-1.55-1.67-2.1-2.43-1.7-.09-.2-.32-.1-.47-.18-.13-.08-.18-.3-.36-.3"
    />
    <path
      fill="#fff"
      d="M14.42 7.67c-1.43 0-2.7.97-3.09 2.38C11 8.95 10.06 8.2 9.02 8.2c-1.35 0-2.45 1.23-2.45 2.75s1.1 2.75 2.45 2.75c1.04 0 1.96-.74 2.31-1.83a3.2 3.2 0 0 0 3.1 2.37 3.25 3.25 0 0 0 3.21-3.28 3.25 3.25 0 0 0-3.22-3.3"
    />
    <path
      fill="#fff"
      d="M9.55 10.73a.67.67 0 1 0 0-1.34.67.67 0 0 0 0 1.34M2.86 10.96a1.14 1.14 0 1 0 0-2.27 1.14 1.14 0 0 0 0 2.27"
    />
    <path
      fill="#000"
      d="M2.84 8.52a1.6 1.6 0 0 0-1 .4q-.34.28-.55.71t-.27.95a3.4 3.4 0 0 0 .42 2.02q.25.46.61.76.37.3.79.43.41.13.82.04c.54-.11 1-.5 1.29-1.07.28-.58.35-1.3.21-2a3 3 0 0 0-.87-1.63 2 2 0 0 0-1.45-.6m.02.17a1.14 1.14 0 1 1 0 2.27 1.14 1.14 0 0 1 0-2.27M9.55 9.26q-.3 0-.57.13a2 2 0 0 0-.47.4q-.21.25-.32.57a2.1 2.1 0 0 0 .32 1.96q.2.25.47.39a1.3 1.3 0 0 0 1.13 0q.28-.14.48-.39.21-.25.32-.58a2.1 2.1 0 0 0-.32-1.96 2 2 0 0 0-.48-.39 1 1 0 0 0-.56-.13m0 .13a.67.67 0 1 1 0 1.34.67.67 0 0 1 0-1.34M15.2 8.9a2 2 0 0 0-1.4.63 2.3 2.3 0 0 0-.44 2.38q.16.4.43.71.28.3.65.48a1.84 1.84 0 0 0 2.17-.48q.29-.3.44-.7a2.4 2.4 0 0 0-.44-2.39 2 2 0 0 0-1.4-.64m0 .13a.86.86 0 1 1 0 1.71.86.86 0 0 1 0-1.71"
    />
    <path fill="#fff" d="M15.2 10.74a.86.86 0 1 0 0-1.71.86.86 0 0 0 0 1.71" />
  </svg>,
  "Gimp",
);
export default GimpIcon;
